import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getOneBlog, updateBlog } from 'slice/blogSlice';
import { toast } from 'react-toastify';
import { useParams, useNavigate } from 'react-router-dom';

const UpdateBlog = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { loading, data } = useSelector((state) => state.blog);

  const [formData, setFormData] = useState({
    title: '',
    description: '',
    image: '',
    imageUpdate: null,
  });

  useEffect(() => {
    dispatch(getOneBlog(id));
  }, [dispatch, id]);

  useEffect(() => {
    if (data && Object.keys(data).length > 0) {
      setFormData({
        title: data.title || '',
        description: data.description || '',
        image: data.image || '',
        imageUpdate: null,
      });
    }
  }, [data]);

  const handleChange = (e) => {
    const { name, type, value, files } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === 'file' ? files[0] : value,
    }));
  };

 const handleSubmit = (e) => {
  e.preventDefault();
  const payload = new FormData();
  payload.append('title', formData.title);
  payload.append('description', formData.description);
  if (formData.imageUpdate) {
    payload.append('image', formData.imageUpdate);
  }

  dispatch(updateBlog({ id, data: payload }))
    .then((res) => {
      const success = res?.payload?.success;

      if (success) {
        toast.success(res.payload.message || 'Blog updated successfully!');
        navigate('/blog'); 
      } else {
        toast.error(res.payload?.message || 'Failed to update blog');
      }
    })
    .catch((error) => {
      console.error('Error updating blog:', error);
      toast.error('Something went wrong while updating');
    });
};

  return (
    <div className="container-fluid px-lg-5">
      <div className="mainheadig">
        <h4 className="text-white font-weight-bold">Update Blog</h4>
      </div>

      <form onSubmit={handleSubmit}>
        <div className="row p-3">
          <div className="col-sm-6 mt-2">
            <label htmlFor="title">Title</label>
            <input
              type="text"
              name="title"
              className="form-control"
              value={formData.title}
              onChange={handleChange}
              placeholder="Enter blog title"
              required
            />
          </div>

          <div className="col-sm-6 mt-2">
            <label htmlFor="description">Description</label>
            <textarea
              name="description"
              className="form-control"
              rows={4}
              value={formData.description}
              onChange={handleChange}
              placeholder="Enter blog description"
              required
            />
          </div>

          <div className="col-sm-6 mt-3">
            <label htmlFor="imageUpdate">Upload Image</label>
            <input
              type="file"
              name="imageUpdate"
              className="form-control"
              accept="image/*"
              onChange={handleChange}
            />
          </div>

          {formData.image && (
            <div className="col-sm-4 mt-3">
              <img
                src={`${process.env.REACT_APP_BACKEND}uploads/blogs/${formData.image}`}
                alt="Blog"
                className="img-thumbnail"
                width={150}
              />
            </div>
          )}
        </div>

        <div className="my-3 text-right">
          <button className="btn btn-primary" disabled={loading}>
            {loading ? 'Updating...' : 'Update Blog'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default UpdateBlog;
